export default __webpack_public_path__ + "static/team01-7300fd43089846f9b5fc6f540f614100.webp";